import React, { useContext, useState } from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { Alert, Button, Menu, MenuItem, Stack, TextField } from '@mui/material'
import BigModal from '../../../../components/Modals/BigModal'
import SafeguardingReview from './SafeguardingReview'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { GlobalContext, UserContext } from '../../../../App'
import API from '../../../../services/API'

const Safeguarding = ({ safeguarding, setRecord, epcrID }) => {
  const [openManagerReview, setOpenManagerReview] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)

  const { user } = useContext(UserContext)
  const { setToast } = useContext(GlobalContext)

  const handleMarkFollowUpComplete = () => {
    API.put(`/epcr/${epcrID}`, {
      'safeguarding.managerReview.followUpComplete': true,
    }).then((res) => {
      if (res.status === 200) {
        setRecord((prev) => ({
          ...prev,
          safeguarding: {
            ...prev.safeguarding,
            managerReview: {
              ...prev.safeguarding.managerReview,
              followUpComplete: true,
            },
          },
        }))
        setToast({ message: 'Follow Up Completed' })
        setOpenManagerReview(false)
        API.post('/epcr/clinicaladvice', {
          epcr: epcrID,
          note: 'Safeguarding Follow Up Completed',
          showInRecord: false,
        }).then((res) => {
          if (res.status === 200) {
            // setRecord((prev) => ({
            //   ...prev,
            //   clinicalAdviceLineNotes: [
            //     ...prev.clinicalAdviceLineNotes,
            //     {
            //       person: {
            //         firstName: user.firstName,
            //         lastName: user.lastName,
            //         photograph: user.photograph,
            //       },
            //       note: 'Safeguarding Follow up Completed',
            //       showInRecord: false,
            //       epcr: epcrID,
            //       createdAt: new Date(),
            //     },
            //   ],
            // }))
          }
        })
        setMenuAnchorEl(null)
      }
    })
  }

  const Concerns = [
    {
      label: 'Concerns',
      value: safeguarding.concernsDetails,
      fullWidth: true,
    },
    {
      label: 'Discussed With',
      value: safeguarding.discussedWith.join(', '),
      fullWidth: true,
    },
    {
      label: 'Referral Made',
      value: safeguarding.referralMade ? 'Yes' : 'No',
      fullWidth: true,
    },
    {
      label: 'Referral Info',
      value: safeguarding.referralInfo,
      fullWidth: true,
    },
  ]

  const concernsPresent = safeguarding.concerns || safeguarding.concernsDetails

  return (
    <>
      <DetailsBox
        title="Safeguarding"
        buttonRight={
          setRecord && (
            <Button
              color={concernsPresent ? 'anRed' : 'inherit'}
              variant="outlined"
              size="small"
              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
              endIcon={<ArrowDropDownIcon />}
            >
              Actions
            </Button>
          )
        }
        rows={
          safeguarding.concerns || safeguarding.concernsDetails ? Concerns : []
        }
        sx={{
          ...(safeguarding.concerns && {
            border: '2px solid #E32525bf',
          }),
        }}
      >
        {!safeguarding.concerns && !safeguarding.concernsDetails ? (
          <Alert severity="success">No Concerns</Alert>
        ) : (
          <Divider />
        )}
        <Menu
          open={!!menuAnchorEl}
          anchorEl={menuAnchorEl}
          onClose={() => setMenuAnchorEl(null)}
        >
          <MenuItem onClick={() => setOpenManagerReview(true)}>
            {safeguarding.managerReview ? 'Edit Review' : 'Review'}
          </MenuItem>
          {safeguarding.managerReview?.followUpRequired &&
            safeguarding.managerReview?.followUpComplete === false &&
            safeguarding?.managerReview?.reviewedBy?._id === user._id && (
              <MenuItem
                onClick={() => {
                  handleMarkFollowUpComplete()
                  setMenuAnchorEl(null)
                }}
              >
                Mark Follow Up Complete
              </MenuItem>
            )}
        </Menu>
        {safeguarding.managerReview && (
          <>
            <Typography variant="title3">Manager / DSL Review</Typography>
            <DetailRow
              label="Actioned"
              value={moment(safeguarding.managerReview.actionedDate).format(
                'DD MMM YYYY HH:mm',
              )}
            />
            <DetailRow
              label="Reviewed By"
              value={
                safeguarding.managerReview.reviewedBy?.firstName +
                ' ' +
                safeguarding.managerReview.reviewedBy?.lastName
              }
            />
            <DetailRow label="Notes" value={safeguarding.managerReview.notes} />
            <DetailRow
              label="Referral To"
              value={safeguarding.managerReview.referralTo}
            />
            {/* TODO: <DetailRow label="Referral Letter" value="DOC" /> */}
            <DetailRow
              label="Followup Required"
              value={safeguarding.managerReview.followUpRequired ? 'Yes' : 'No'}
            />
            {safeguarding.managerReview.followUpRequired && (
              <>
                <DetailRow
                  label="Followup Details"
                  value={safeguarding.managerReview.followUpDetails}
                />
                <DetailRow
                  label="Followup Date"
                  value={moment(safeguarding.managerReview.followUpDate).format(
                    'Do MMM YYYY',
                  )}
                />
                <DetailRow
                  label="Follow Up Complete"
                  value={
                    safeguarding.managerReview.followUpComplete ? 'Yes' : 'No'
                  }
                />
              </>
            )}
          </>
        )}
      </DetailsBox>
      <BigModal
        open={openManagerReview}
        onClose={() => setOpenManagerReview(false)}
        style={{ borderColor: '#E32525', borderWidth: 2 }}
      >
        <SafeguardingReview
          Concerns={Concerns}
          setOpenManagerReview={setOpenManagerReview}
          epcrID={epcrID}
          safeguarding={safeguarding}
          setRecord={setRecord}
          setMenuAnchorEl={setMenuAnchorEl}
        />
      </BigModal>
    </>
  )
}

export default Safeguarding
